import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Helmet } from 'react-helmet'

import { HydraTable, Heading, TextFilter, StyledCheckbox } from '@peracto/peracto-ui'

import { GET_LIST, useClient } from '@peracto/client'

const ElementAreasList = () => {
    const [selectedColumns, onSelectColumn] = useState({})
    const { client } = useClient()

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
            sortType: 'basic',
            Cell: row => (
                <Link to={`/element-areas/${row.row.original.code}`}>{row.cell.value}</Link>
            ),
            selectable: false,
            disableSorting: true,
        },
        {
            Header: 'Code',
            accessor: 'code',
            sortType: 'basic',
            selectable: false,
            disableSorting: true,
        },
        {
            Header: 'Assigned Element',
            accessor: 'contentElementAreas',
            id: 'assignedElement',
            Cell: ({ cell: { value } }) => {
                const title = value?.length > 0 ? value[0]?.content?.title || '-' : '-'
                return title
            },
            selectable: false,
            disableSorting: true,
        },
    ])

    const onFetchData = options => client(GET_LIST, 'content-elements', options)

    return (
        <>
            <Helmet>
                <title>Element Areas | Peracto</title>
            </Helmet>
            <Heading name="Element Areas" />

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onFetchData={onFetchData}
                                onSelectColumn={onSelectColumn}
                                defaultFilters={{
                                    name: '',
                                    title: '',
                                    locale: '',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ElementAreasList
